module.exports = __webpack_public_path__ + "img/banner34.9f553af1.png";